"use client";

import { faArrowRight, FontAwesomeIcon } from '@/constants/icons';

const ScrollToDetails = () => {
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        document.getElementById('fullDetails')?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <a
            href="#fullDetails"
            onClick={handleClick}
            className="inline-flex items-center gap-2 text-[11px] font-black text-[#f23017] uppercase tracking-[0.2em] no-underline hover:opacity-75 transition-opacity w-fit cursor-pointer"
        >
            See Full Details
            <FontAwesomeIcon icon={faArrowRight} className="text-[10px]" />
        </a>
    );
};

export default ScrollToDetails;
